module.exports = __webpack_public_path__ + "img/bg-operation-item-1.47cfc695.png";